import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { AppFrame } from 'transfix-ui/components/AppFrame'
import { stepRoutesByName } from 'apps/fleet-planner/constants'
import { useOnboardingWizardContext } from 'apps/fleet-planner/context'
import { OnboardingStepCarriers } from './OnboardingStepCarriers'
import { OnboardingStepCarriersApproval } from './OnboardingStepCarriersApproval'
import { OnboardingStepCheckEmail } from './OnboardingStepCheckEmail'
import { OnboardingStepEmailInput } from './OnboardingStepEmailInput'
import { OnboardingStepLoading } from './OnboardingStepLoading'
import { OnboardingStepNewUser } from './OnboardingStepNewUser'
import { OnboardingStepOptions } from './OnboardingStepOptions'
import { OnboardingStepReturningUser } from './OnboardingStepReturningUser'

/**
 * Used to guide users through a full-page, multi-step onboarding flow
 */
export const OnboardingWizard = () => {
  const { mobileApp } = useOnboardingWizardContext()
  return (
    <AppFrame isMobileApp={mobileApp}>
      <Switch>
        {/** Email Input */}
        <Route
          exact
          path={[stepRoutesByName.emailInput, stepRoutesByName.index]}
          component={OnboardingStepEmailInput}
        />
        {/** Check Email */}
        <Route exact path={[stepRoutesByName.checkEmail]} component={OnboardingStepCheckEmail} />
        {/** New User */}
        <Route exact path={[stepRoutesByName.newUser]} component={OnboardingStepNewUser} />
        {/** Returning User */}
        <Route
          exact
          path={[stepRoutesByName.returningUser]}
          component={OnboardingStepReturningUser}
        />
        {/** Options */}
        <Route exact path={[stepRoutesByName.options]} component={OnboardingStepOptions} />
        {/** Carriers */}
        <Route exact path={[stepRoutesByName.carriers]} component={OnboardingStepCarriers} />
        {/** Unapproved Carriers */}
        <Route
          exact
          path={[stepRoutesByName.unapprovedCarriers]}
          component={OnboardingStepCarriersApproval}
        />
        {/** Loading */}
        <Route exact path={[stepRoutesByName.loading]} component={OnboardingStepLoading} />
      </Switch>
    </AppFrame>
  )
}
